<template>
    <v-form @submit.prevent="generateCOE" ref="form">
        <v-card class="rounded-4">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold">Generate COE</span>
                <v-spacer></v-spacer>
                <v-btn icon :disabled="disabled" @click.native="closeDialog()">
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="form-container">
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-row">
                        <v-autocomplete
                            v-model="signatoryUserId"
                            :disabled="disabled"
                            :items="employees"
                            :loading="loading_employees"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Signatory"
                            item-text="name"
                            item-value="userId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                <v-list-tile-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout row wrap> 
                    <v-flex xs12 sm12 class="form-row">
                        <v-select
                            label="Signature Option"
                            :items="signatoryTypes"
                            :rules="[rules.required]" 
                            item-text="description"
                            item-value="signatoryType"
                            :disabled="disabled"
                            v-model="signatoryType"
                            persistent-hint
                            :hint="signatoryHint"
                        ></v-select><br>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="mr-25">
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :loading="loading_generate" dark>Generate COE</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import employeeApi from '@/api/employees'
import hr201Api from '@/api/hr201'
import awsS3Helper from '@/helpers/aws-s3'
import pageKeys from '@/common/pagekeys'

export default {
    data () {
        return {
            common_data: null,
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            loading_employees: false,
            loading_generate: false,
            rules: {
                required: value => !!value || 'Required field.',
            }, 
            signatoryTypes: [
                { signatoryType: 1, description: "No signature" },
                { signatoryType: 2, description: "Include HR signature" }
            ],
            employees: [],
            userId: null, 
            signatoryUserId: null,
            signatoryType: null
        }
    },
    methods: {
        async getEmployees() {
            try {
                this.loading_employees = true
                this.employees = []
                const response = await employeeApi.getAll()
                if (response && response.status == 200) {
                    const members = response.data.employees
                    members.forEach(item => {
                        this.employees.push({
                            userId: item.userId,
                            name: item.firstName + " " + item.lastName,
                            avatar: awsS3Helper.getAvatarUrl(item.userId),
                        })
                    })
                }
                this.loading_employees = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        async generateCOE() {
            try {
                this.loading_generate = true
                this.disabled = true
                if (this.$refs.form.validate()) {
                    var data = {
                        userId: this.userId,                    //employee who requested coe
                        signatoryUserId: this.signatoryUserId,  //coe signatory
                        signatoryType: this.signatoryType
                    }
                    const response = await hr201Api.generateCOE(data, this.selectedPageKey)
                    if (response.status == 200) {
                        this.$emit('send', response.data)
                        this.closeDialog()
                    }
                }
                this.loading_generate = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setParam(userId) {
            this.signatoryType = 1
            this.userId = userId
            this.signatoryUserId = this.$store.state.userId //default to logged-in user
            if (!this.employees.length) {
                await this.getEmployees()
            }
        },
        closeDialog() {
            this.$emit('update:dialogGenerateCOE', false)
        },
    },
    computed: {
        signatoryHint() {
            return this.signatoryType == 1 ? 'A note will appear: “System generated. No signature required.”' : 'A signatory section with name and position will be added at the bottom.'
        },
        isMy201FilesPage() {
            return !this.$route.params.userId
        },
        selectedPageKey() {
            return this.isMy201FilesPage ? pageKeys.myhr201 : pageKeys.hr201
        },
    },
    created() {}
}
</script>
<style scoped>
.form-container {
    padding:10px 20px 0px 20px;
}
.form-row {
    padding: 0px 15px 0px 15px;
}
</style>